// extracted by mini-css-extract-plugin
module.exports = {"createBtn":"Empty_createBtn__XfFt_"};